import React, { useState } from "react";
import About from "./Components/About"; 
import Navbar from "./Components/Navbar";
import TextForm from "./Components/TextForm";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
 const [mode, setMode] = useState('light');
 const [switchText, setswitchText] = useState('Enable Darkmode');
 

 const toggleMode = ()=>{
  if(mode==='light'){
    setMode('dark')
    document.body.style.backgroundColor = '#042743' 
    setswitchText('Disable Darkmode')
  }
  else{
    setMode('light')
    document.body.style.backgroundColor = 'white'
    setswitchText('Enable Darkmode')
  }
  
 }
  return (
    <>
    <Router>
      <Navbar title="TextUtils" mode={mode} toggleMode={toggleMode} switchText={switchText}/>
      <Routes>
          <Route exact path="/about" element={<About mode={mode}/>}></Route>
          <Route exact path="/" element={<TextForm mode={mode}/>}></Route>
        </Routes>
    </Router>
    </>
  );
}

export default App;

